// «Solo cuenta la última» (Sala CRM<->HCE, rebanada 3): cada recarga toma un número al empezar; al terminar, solo la más reciente puede
// escribir el estado. Así una respuesta vieja que llega tarde (dos recargas en vuelo, en cualquier orden) nunca pisa a la nueva.
export function crearUltimaPeticion() {
  let n = 0;
  return {
    /** Empieza una recarga: devuelve un testigo cuyo `vigente()` es true solo mientras no haya empezado otra. */
    nueva: () => {
      const mia = ++n;
      return { vigente: () => mia === n };
    },
  };
}
